/**
 * 入场暗号（ADR-0011，design §11.8）前端这边的规矩：哪句该在这次入场时出现、「昨夜留」怎么说、停多久、哪些成了足迹。
 * 两个人都拿得到全文（本来就是写给 Ta 的）；什么时候显示由这里决定。
 */
import { daysBetween, localDateOf, type NoteDto } from '@star-sea/shared';

/** Ta 留给我、我还没看到的那句（每人最多一条；万一有几条，取最后改的） */
export function pendingNote(notes: Iterable<NoteDto>, me: string): NoteDto | null {
  let best: NoteDto | null = null;
  for (const n of notes) if (n.to === me && !n.readAt && (!best || n.updatedAt > best.updatedAt)) best = n;
  return best;
}

/** 我留给 Ta、Ta 还没看到的那句 */
export function myPendingNote(notes: Iterable<NoteDto>, me: string): NoteDto | null {
  for (const n of notes) if (n.from === me && !n.readAt) return n;
  return null;
}

/** 我留的、Ta 最近看到的那句（留言框里说一声「上一句 Ta 10 月 3 日看到了」） */
export function lastReadNote(notes: Iterable<NoteDto>, me: string): NoteDto | null {
  let best: NoteDto | null = null;
  for (const n of notes) if (n.from === me && n.readAt && (!best || n.readAt > best.readAt!)) best = n;
  return best;
}

/** 看过的暗号是足迹，按留的那天、再按留的先后 */
export function footprintsOf(notes: Iterable<NoteDto>): NoteDto[] {
  return [...notes].filter((n) => n.readAt).sort((a, b) => (a.date !== b.date ? (a.date < b.date ? -1 : 1) : a.createdAt < b.createdAt ? -1 : a.createdAt > b.createdAt ? 1 : 0));
}

/** 「刚刚留」「今晚留」「昨夜留」「前天留」「5 天前留」「9 月 20 日留」：按看的人这台设备的时间 */
export function leftWhen(at: string, now: number): string {
  const t = new Date(at), h = t.getHours();
  if (now - t.getTime() < 3_600_000) return '刚刚留';
  const days = daysBetween(localDateOf(t), localDateOf(now));
  if (days <= 0) return h < 5 ? '凌晨留' : h < 11 ? '早上留' : h < 18 ? '今天留' : '今晚留';
  if (days === 1) return h >= 18 ? '昨夜留' : '昨天留';
  if (days === 2) return '前天留';
  if (days < 7) return `${days} 天前留`;
  const same = t.getFullYear() === new Date(now).getFullYear();
  return `${same ? '' : `${t.getFullYear()} 年 `}${t.getMonth() + 1} 月 ${t.getDate()} 日留`;
}

/** 入场时那句下面的一行小字：「来自 阿禾 · 昨夜留」 */
export function noteByline(note: NoteDto, fromName: string, now: number): string {
  return `来自 ${fromName} · ${leftWhen(note.updatedAt, now)}`;
}

/** 入场时停多久（秒）：至少 3 秒，长的按一秒八个字左右加，最多 8 秒；点一下照样提前走 */
export function noteHold(text: string): number {
  return Math.min(8, Math.max(3, 1.5 + [...text].length / 8));
}
